import Swiper from 'swiper';

export function contactsSlider() {

    let sliderContacts = new Swiper('.contacts-slider', {
        containerModifierClass: 'contacts-slider',
        wrapperClass: 'contacts-slider__wrapper',
        slideClass: 'contacts-slide',
        slideActiveClass: 'is-active',
        slidesPerView: 3,
        breakpoints: {
            1319: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            999: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            767: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            320: {
                centeredSlides: true,
                slidesPerView: 1,
                spaceBetween: 0,
                width: 280,
            },
        },
        navigation: {
            nextEl: '.contacts-button-next',
            prevEl: '.contacts-button-prev',
        },
        pagination: {
            el: '.contacts-slider__pagination',
            type: 'bullets',
            bulletClass: 'contacts-slider__bullet',
            bulletActiveClass: 'contacts-slider__bullet_active',
            clickable: true,
        },
    });
}